import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [CardModule, RouterOutlet],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent implements OnInit {
  service = inject(UserService)

  ngOnInit(): void {
    this.service.title.update((value) => 'Usuarios')
  }
}
